import createBaseService from "@/api/base-service.ts";
import type { CourtType } from "../../types/court-type";

const courtTypeService = {
	...createBaseService<CourtType>("/court-types"),
};

export default courtTypeService;
